// extracted by mini-css-extract-plugin
export default {"fullWidth":"Eu-z","image":"Fu-z","lazyLoadPicture":"Gu-z","lazyLoadSpinner":"Hu-z","lazyLoadSpin":"Iu-z","lazyLoadImage":"Ju-z","hasStyledAspectRatio":"Ku-z"};